import React, {useCallback, useEffect, useState} from 'react';
import eventBus from "infrastructure/common/eventBus";
import {ModalEvents} from "./ModalEvents";
import Modal from "./Modal";

export const ModalContainer = () => {
  const modalRef = React.useRef();
  const contentRef = React.useRef();
  const propsRef = React.useRef({});
  const [, forceUpdate] = useState(0);

  const defaultCloseAction = () => eventBus.dispatch(ModalEvents.CLOSE);

  const openFn = useCallback(({detail: {content, ...others}}) => {
    contentRef.current = content;
    propsRef.current = others;
    forceUpdate(c => c + 1);
    modalRef?.current?.open();
  }, [forceUpdate]);

  const closeFn = useCallback(() => {
    contentRef.current = null;
    propsRef.current = {};
    forceUpdate(0);
    modalRef?.current?.close();
  }, [forceUpdate]);

  useEffect(() => {
    eventBus.on(ModalEvents.OPEN, openFn);
    eventBus.on(ModalEvents.CLOSE, closeFn);

    return () => {
      eventBus.remove(ModalEvents.OPEN, openFn);
      eventBus.remove(ModalEvents.CLOSE, closeFn);
    };
  });

  const ModalContent = contentRef.current;
  const { onClose, className, title } = propsRef.current;

  return (
    <Modal ref={modalRef} title={title} onClose={onClose || defaultCloseAction} className={className}>
      { contentRef.current && <ModalContent {...propsRef.current} /> }
    </Modal>
  );
};

export default React.memo(ModalContainer);
